import { motion } from 'framer-motion';
import { X, Loader2, XCircle } from 'lucide-react';

const REASONS = ['Too busy', 'Too hard', 'Forgot', 'Not the right time', 'Lost motivation', 'Something else'];

export default function FailMissionModal({
  open,
  reason,
  setReason,
  notes,
  setNotes,
  failing,
  onClose,
  onSubmit,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 flex items-end sm:items-center justify-center z-50 p-4" onClick={onClose}>
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-white rounded-3xl w-full max-w-md p-6 border-b-4 border-[#E5E5E5]"
        onClick={(e) => e.stopPropagation()}
        data-testid="fail-modal"
      >
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-2">
            <XCircle size={24} strokeWidth={3} color="#FF8E2C" />
            <h3 className="text-xl font-extrabold">No worries</h3>
          </div>
          <button onClick={onClose} className="p-1" data-testid="close-fail-modal">
            <X size={24} strokeWidth={3} />
          </button>
        </div>
        <p className="text-sm text-[#AFAFAF] font-bold mb-4">
          Tell us what stopped you. Your coach will adapt the next mission to make it easier.
        </p>
        <label className="block">
          <span className="text-xs uppercase font-extrabold text-[#AFAFAF]">What stopped you?</span>
          <div className="grid grid-cols-2 gap-2 mt-2">
            {REASONS.map((r) => (
              <button
                key={r}
                type="button"
                onClick={() => setReason(r)}
                className={`px-3 py-2 rounded-full text-sm font-extrabold border-2 border-b-4 ${
                  reason === r
                    ? 'bg-[#FF8E2C] text-white border-[#E07720]'
                    : 'bg-white border-[#E5E5E5] text-[#4B4B4B]'
                }`}
                data-testid={`fail-reason-${r.replace(/\s+/g, '-').toLowerCase()}`}
              >
                {r}
              </button>
            ))}
          </div>
        </label>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="gm-input text-base mt-3"
          rows={3}
          maxLength={400}
          placeholder="Any more context? (optional)"
          data-testid="fail-notes-input"
        />
        <button
          onClick={onSubmit}
          disabled={failing || reason.trim().length < 2}
          className="gm-btn gm-btn-danger w-full text-lg py-3 mt-3"
          data-testid="submit-fail"
        >
          {failing ? (
            <><Loader2 size={20} strokeWidth={3} className="animate-spin" /> Analysing…</>
          ) : (
            <>Submit & adapt</>
          )}
        </button>
      </motion.div>
    </div>
  );
}
